<template>
  <v-dialog
      v-model="downloadDialog"
      max-width="500"
  >
    <v-card>
      <v-overlay :value="loading" absolute>
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-card-title style="height: 64px; box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.22);">
        <span style="font-size: 16px">IMAGERY</span>
        <v-spacer/>
        <v-btn icon small @click="downloadDialog = false">
          <img alt="download" :src="require('@/assets/icon/close.svg')">
        </v-btn>
      </v-card-title>

      <v-card-text style="max-height: 70vh; overflow-y: auto" class="pa-0">
        <v-layout class="fill-height">
          <v-data-table
              fixed-header
              style="height: 100%"
              height="100%"
              v-model="imageSelected"
              :headers="headers"
              :items="availableImage"
              item-key="id"
              show-select
              class="elevation-1"
          >
          </v-data-table>
        </v-layout>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn dark color="#893ff2" @click="submitDownload"><v-icon>mdi-download</v-icon>Download</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {getImageries, downloadImages} from "@/backend";
import MonthTransform from "@/ultis/converMonth";

export default {
  name: "SelectImage",
  data () {
    return {
      headers: [
        {
          text: 'Image Name',
          align: 'start',
          sortable: false,
          value: 'name',
        }
      ],
      imageSelected: [],
      allImage: [],
      loading: false,
      downloadDialog: false,
      imageType: ''
    }
  },
  computed: {
    availableImage () {
      if (this.imageType === 'input') return this.allImage.filter(val => val.type === 'mosaic')
      else return this.allImage.filter(val => val.type !== 'mosaic')
    }
  },
  methods: {
    openDialog (type) {
      this.imageType = type
      this.imageSelected = []
      this.getData()
      this.downloadDialog = true
    },
    convertMonth (month) {
      return MonthTransform.transformMonthText(month)
    },
    async getData () {
      try {
        this.loading = true
        const res = await getImageries()
        this.allImage = res.data.data
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async submitDownload () {
      try {
        this.loading = true
        const imageIds = []
        this.imageSelected.forEach(image => {
          imageIds.push(image.id)
        })
        const res = await downloadImages({image_ids: imageIds})
        window.open(res.data.data, "_blank")
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
